import investedSaga from './investedSaga';

export default [
  investedSaga(),
];
